export function checkUrlAgainstExcludeList(href, regexArray) {
  const EXCLUDE_LIST = [/object-manager-settings/, /pricing\/\d+/, /account-and-billing\/\d+\/v2\/subscriptions/, /tourId=/, /onboardingTourId=/, /upgrade\/\d+/, /checkout\/\d+/];
  const excludeList = regexArray || EXCLUDE_LIST;
  return excludeList.some(regexString => href.match(regexString));
}
export const isContactPageUrl = pathname => {
  const contactPageRegex = /\/contacts\/\d+\/(contact|record\/0-1)\/(\d+)\/*(\?[A-Za-z=-]+)*$/;
  const matches = pathname.match(contactPageRegex);
  return matches;
};
export const getContactIdFromUrl = url => {
  const pathname = new URL(url).pathname;
  const matches = isContactPageUrl(pathname);
  return Array.isArray(matches) ? matches[2] : undefined;
};
const isPartOfSalesDashboardPromptUrls = pathname => {
  //Urls that are we need to validate for the sales dashboard prompt:

  // calls
  // /contacts/[portalId]/objects/0-48/views/recorded_calls/list

  // companies
  // /contacts/[portalId]/objects/0-2/views/all/list

  // deals
  // /contacts/[portalId]/objects/0-3/views/all/list

  const salesDashboardPromptPageRegex = /\/contacts\/\d+\/objects\/0+-(2|3|48)\/views\/(all|recorded_calls)\/list$/;
  return salesDashboardPromptPageRegex.test(pathname);
};
export const isOnContactListPage = pathname => {
  //Urls that are we need to validate for sales dashboard & ONBU022 prompts:
  // contacts
  // /contacts/[portalId]/objects/0-1/views/all/list

  const onbu022PageRegex = /\/contacts\/\d+\/objects\/0+-1\/views\/(all|recorded_calls)\/list$/;
  return onbu022PageRegex.test(pathname);
};
const isOnContactRecordPage = pathname => {
  // /contacts/[portalId]/record/0-1/

  const contactRecordRegex = /\/contacts\/\d+\/record\/0+-1\//;
  return contactRecordRegex.test(pathname);
};
const isOnCommerceHome = pathname => {
  const regexp = /\/commerce\/\d+/;
  return regexp.test(pathname);
};
export const isOnPaymentsPage = pathname => {
  const paymentsPagePattern = /\/sales\/payments/;
  return paymentsPagePattern.test(pathname);
};
export const isOnMarketingHomePage = pathname => {
  const marketingHomePagePattern = /\/marketing\/\d+\/?$/;
  return marketingHomePagePattern.test(pathname);
};
export const isOnInvoicesPage = pathname => {
  const invoicesPagePattern = /\/objects\/0-53\/views/;
  const invoicesZetoStatePagePattern = /\/commerce-get-started\/\d+\/invoices/;
  return invoicesPagePattern.test(pathname) || invoicesZetoStatePagePattern.test(pathname);
};
export const isOnSubscriptionsPage = pathname => {
  const subscriptionsPagePattern = /\/objects\/0-69\/views/;
  return subscriptionsPagePattern.test(pathname);
};
const isOnMeetingsPage = pathname => {
  const meetingsPagePattern = /\/meetings\/\d+/;
  return meetingsPagePattern.test(pathname);
};
export const isOnReportsListPage = pathname => {
  const reportsListPagePattern = /\/reports-list\/\d+/;
  return reportsListPagePattern.test(pathname);
};
export const isOnReportsAIBuilderPage = pathname => {
  const reportsAIBuilderPagePattern = /\/discover\/\d+\/create\/reports\/ai-builder/;
  return reportsAIBuilderPagePattern.test(pathname);
};
export const isOnDashboardsCreatePage = pathname => {
  const dashboardsCreatePagePattern = /\/discover\/\d+\/create\/dashboards/;
  return dashboardsCreatePagePattern.test(pathname);
};
export const isOnAdvancedBuilderPage = pathname => {
  const advancedBuilderPagePattern = /\/advanced-builder\/\d+/;
  return advancedBuilderPagePattern.test(pathname);
};
export const isOnJourneyBuilderPage = pathname => {
  const journeyBuilderPagePattern = /\/journey-builder\/\d+/;
  return journeyBuilderPagePattern.test(pathname);
};
export const getLocationForModalFetch = pathname => {
  if (isPartOfSalesDashboardPromptUrls(pathname)) {
    return 'sales-hub-starter-reporting-prompt';
  }
  if (isOnContactListPage(pathname)) {
    return 'contact-list-page';
  }
  if (isOnCommerceHome(pathname)) {
    return 'commerce';
  }
  if (isOnInvoicesPage(pathname)) {
    return 'invoices';
  }
  if (isOnPaymentsPage(pathname)) {
    return 'payments';
  }
  if (isOnSubscriptionsPage(pathname)) {
    return 'subscriptions';
  }
  if (isOnMarketingHomePage(pathname)) {
    return 'marketing-home';
  }
  if (isOnMeetingsPage(pathname)) {
    return 'meetings-page';
  }
  if (isOnContactRecordPage(pathname)) {
    return 'contact-record-page';
  }
  if (isOnReportsListPage(pathname)) {
    return 'reports-list';
  }
  if (isOnReportsAIBuilderPage(pathname)) {
    return 'discover-ai-builder';
  }
  if (isOnDashboardsCreatePage(pathname)) {
    return 'discover-create-reports';
  }
  if (isOnAdvancedBuilderPage(pathname)) {
    return 'advanced-builder';
  }
  if (isOnJourneyBuilderPage(pathname)) {
    return 'journey-builder';
  }
  return pathname.split('/')[1];
};